import React, {Component} from 'react';
import {Api} from '../../api';
import SelectInput from '../../components/Common/SelectInput'
import {getAuthToken} from '../../utils';
import {connect} from 'react-redux';
import './CertificateTypeSelection.scss';
import ButtonInput from "../../components/Common/ButtonInput";


class CertificateTypeSelection extends Component {

    state = {
        countries: [],
        countryTitle: '',
        countryId: null,
        providerTitle: '',
        providers: [],
        companyTypeList: [],
        companyType: '',
        isLoading: true,
        OSName: null,
        disabledNext: true
    };

    // https://blockchain.info/rawtx/db8c91ad78f6905d562db9ba460c70379e6b47b395728d9b66a822a56088942f
    componentWillUnmount() {
        clearInterval(this.interval);
    }

    componentDidUpdate() {
    }

    componentWillMount() {
        this.props.handleLoader(true);
    }

    componentDidMount() {
        const authToken = getAuthToken();

        let OSName = null;
        if (navigator.appVersion.indexOf("Win") != -1) OSName = "win";
        if (navigator.appVersion.indexOf("Mac") != -1) OSName = "mac";

        this.setState({OSName});

        console.log("I'm here in certificate type selection");
        this.getPersonalData();
        setTimeout(() => this.props.handleLoader(false), 200);
        this.interval = setInterval(() => this.getPersonalData(), 2000);

        Api.get(`applet/countries`, authToken)
            .then((response) => {
                console.log(response, 'response');

                let countries = response.data.map((country, index) => ({
                    id: country.id,
                    value: country.id,
                    title: country.country,
                }));
                Api.get(`applet/providers?country=${countries[0].id}`, authToken)
                    .then((response) => {

                        let providers = response.data.map((provider, index) => ({
                            id: provider.id,
                            value: provider.id,
                            title: provider.providerName,
                        }));

                        console.log(countries[0]);
                        this.setState({
                            providers: providers,
                            providerTitle: providers[0].title,
                            countries: countries,
                            countryTitle: countries[0].title,
                            countryId: countries[0].id,
                            isLoading: false,
                            disabledNext: false
                        });

                        setTimeout(() => this.props.handleLoader(false), 200)
                    }).catch((error) => {
                    setTimeout(() => this.props.handleLoader(false), 200)
                });

            }).catch((error) => {
            this.setState({isLoading: false});
            setTimeout(() => this.props.handleLoader(false), 200)
        });
    }

    getPersonalData = () => {
        const authToken = getAuthToken();
        // this.props.handleLoader(true);

        Api.get(`certificates/current`, authToken)
            .then((response) => {
                if (response.data.length > 0) {
                    const certificates = response.data;
                    console.log(certificates);
                    let allCompaniesConfirmed = true;
                    for (const certificate of certificates) {
                        let hasCompany = false;
                        for (const company of certificate.companies) {
                            if (company) {
                                hasCompany = true;
                            }
                            if (!company.confirmed) {
                                allCompaniesConfirmed = false;
                            }
                        }

                        if (!hasCompany) {
                            this.props.history.push('/user/personal-data/search-for-companies');
                            return;
                        }
                    }
                    if (allCompaniesConfirmed) {
                        this.props.history.push('/user/personal-data/wait-for-payment');

                    } else {
                        this.props.history.push('/user/personal-data/confirm-companies');

                    }
                }
            }).catch((error) => {
            setTimeout(() => this.props.handleLoader(false), 200)
        });
    };

    render() {
        const {countries, countryTitle, providers, providerTitle, isLoading, disabledNext} = this.state;

        return (
            <div className='content-wrapper'>
                {!isLoading ?
                    <div className="content">
                        <div className="content-body">
                            <div className="content-title">Select your digital signature</div>
                            <div className="fields-row">
                                <SelectInput name='country'
                                             id='country'
                                             label='Select your country'
                                             value={countryTitle}
                                             required={true}
                                             classes='width-328'
                                             options={countries}
                                             handleChange={(e) => this.handleChange(e)}/>
                            </div>
                            <div className="fields-row">
                                <SelectInput name='provider'
                                             id='ACSKprovider'
                                             label='ACSK provider'
                                             value={providerTitle}
                                             required={true}
                                             classes='width-328'
                                             options={providers}
                                             disabled={providers.length === 0}
                                             handleChange={(e) => this.handleChange(e)}/>
                            </div>
                            <div className="download-desc">
                                <div>Please select type of certificate you are using.</div>
                            </div>
                            <ButtonInput
                                id="next-button"
                                className={'dark-button blue-button search-bth next-button'}
                                disabled={disabledNext}
                                title='Next'
                                handleClick={(e) => this.onNext()}/>
                        </div>
                    </div> :
                    <div></div>
                }
            </div>
        )
    }

    onNext = event => {
        if (this.state.providerTitle == 'Smart ID') {
            this.props.history.push('/user/personal-data/select-smart-id-code');
        }
    };

    handleChange = event => {
        const {errors, countries, providers} = this.state;
        console.log(event.target.name, 'event.target.name', event.target.value);

        this.setState({
            [event.target.name]: event.target.value,
        });

        if (event.target.name === 'provider') {
            const providerTitle = providers.map((provider, index) => {
                if (provider.title === event.target.value) {
                    console.log(provider);
                    return provider.title;
                }
            });

            this.setState({providerTitle: providerTitle[0], disabledNext: false});
        }

        if (event.target.name === 'country') {
            this.props.handleLoader(true);
            const authToken = getAuthToken();

            let countryId = null;

            countries.map((country, index) => {
                if (country.title === event.target.value) countryId = country.id;
            });

            Api.get(`applet/providers?country=${countryId}`, authToken)
                .then((response) => {

                    let providers = response.data.map((provider, index) => ({
                        id: provider.id,
                        value: provider.id,
                        title: provider.providerName,
                    }));

                    this.setState({providers, countryId, disabledNext: true, providerTitle: providers[0].title, provider: ''});

                    setTimeout(() => this.props.handleLoader(false), 200)
                }).catch((error) => {
                setTimeout(() => this.props.handleLoader(false), 200)
            });
        }
    };
}

function mapStateToProps(state) {
    return {};
}

export default connect(mapStateToProps)(CertificateTypeSelection);


// WEBPACK FOOTER //
// ./src/views/CertificateTypeSelection/CertificateTypeSelection.js